import { CurrentUserContext } from '../utils/currentUserContext'
import type { FeatureFlag } from '../utils/featureFlags'

export type HasFeatureFlag = (featureFlag: FeatureFlag) => boolean

export function useHasFeatureFlag(): HasFeatureFlag
export function useHasFeatureFlag(featureFlag: FeatureFlag): boolean
export function useHasFeatureFlag(featureFlag?: FeatureFlag) {
  const currentUser = CurrentUserContext.useSafeContext()

  const hasFeatureFlag: HasFeatureFlag = (_featureFlag) => {
    return currentUser?.feature_flags.has(_featureFlag) === true
  }

  return featureFlag === undefined
    ? hasFeatureFlag
    : hasFeatureFlag(featureFlag)
}
